import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Form, Input, Icon, Upload, Pagination } from 'antd'
import { DndProvider} from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'react-addons-update';
import {component} from "../../commponents/tableRow"
import './payClass.less'
const FormItem = Form.Item
let qiniuUpUrl = 'https://up-z1.qiniup.com'
let url = process.env.REACT_APP_ENV === "production" ? process.env.REACT_APP_BASE_URL + 'video-wechat-manager/api' : "http://test-videocadmin.codingke.com/video-wechat-manager/api"
class PayDetail extends Component {
  state = {
    showKnowName: false,
    modelTitle: '新增',
    typeQ: 'add',
    courseName: '',
    poster: {},
    price: '',
    reply: '',
    introduce: '',
    replyObj: {},
    replyImg: '',
    imageUrl: '',
    fileList: [],
    iconLoading: false,
    columns: [{
      title: '付费课名称',
      dataIndex: 'courseName',
      align: 'left',
      key: 'courseName',
    },
    {
      title: '价格',
      dataIndex: 'price',
      align: 'center',
      key: 'price'
    },{
      title: '操作',
      align: 'center',
      width: '200px',
      render: (row) => {
        return (
          <div className="all-btn">
            <Button type="link" onClick={() => {this.handleKnow('edit',row)}}>编辑</Button>
            <Button type="link" className="red-color" onClick={() => {
              Modal.confirm({
								title: '删除',
								okText: "确认",
								cancelText: "取消",
								content: '删除后将不可恢复，请谨慎操作！确定要删除吗？',
								onOk: () => {
									this.delStage(row.id)
								},
							});
            }}>删除</Button>
          </div>
        )
      }
    }],
    dataSource: [],
    notChanged: [],
    subjectId: '',
    subName: '',
    detailObj: {},
    token: '',
    infourl: '',
    kefuList: [],
    kefuListurl: '',
    fileListurl: '',
    kefuListloading: false,
    fileListloading: false,
    apiUrl: '',
    total: 0,
    pageNum: 1,
    size: 10
  }
  componentDidMount() {
    // console.log(window.document.domain)
    let {subjectId, subName} = this.props.location.state
    // let url = 'http://test-videocadmin.codingke.com/video-wechat-manager/api/'
    this.setState({subjectId, subName,apiUrl: url},() => {
      this.InitClassHandle()
    })
    this.getToken()
  }
  InitClassHandle() {
    let {pageNum,size, courseName, subjectId} = this.state
    axios.post('paycourse/list',{courseName: courseName, pageSize: size, pageNum, subjectId: subjectId}).then(res => {
      if (res.data.code === '200') {
        let data = res.data.data
        this.setState({total: data.total,notChanged: data.list, dataSource: data.list})
      }
    })
  }
  moveRow = (dragIndex, hoverIndex) => {
    let {dataSource} = this.state
    const dragRow = dataSource[dragIndex];
    this.setState(
			update(this.state, {
				dataSource: {
					$splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
				},
			}),
		);
    let oldSort = []
		for (let i = 0; i < this.state.notChanged.length; i++) {
			oldSort.push({sort: this.state.notChanged[i].sort, id: this.state.dataSource[i].id })
		}
    axios.post('/paycourse/update/sort',oldSort).then(res => {
			if(res.data.code === '200' ){
        oldSort = []
      }
		})
  }
  powerValidateForm = (rule, value, callback) => {
    // let reg = /^[0-9]*(?:\.[0-9]{1,2})?$/
    let reg = /^\d+(\.\d+)?$/
    if(value&&!reg.test(value)) {
      callback('请输入数字')
    }else if(value&&value<=0){
      callback('请输入大于0的数字')
    }else{
      callback()
    }
  }
  presetValidateForm = (rule, value, callback) => {
    let reg = /^([0]|[1-9][0-9]*)$/
    if(value&&!reg.test(value)) {
      callback('请输入正整数')
    }else if(value&&value<=1){
      callback('请输入大于等于1的正整数')
    }else{
      callback()
    }
  }
  handleKnow = (type, obj) => {
    // console.log(type, obj)
    this.setState({typeQ: type, detailObj: obj, showKnowName: true},() => {
      if(type === 'edit'){
        this.getTypeInfo()
      }
    })
  }
  delStage(id) {
    axios.get(`paycourse/delete/${id}`).then(res => {
      // console.log(res.data)
      if(res.data.code !== '200') return message.error(res.data.msg)
      message.success('删除成功')
      this.InitClassHandle()
    })
  }
  getTypeInfo() {
    let {detailObj} = this.state
    this.setState({
      fileListurl: detailObj.coverUrl,
      kefuListurl: detailObj.replyImg
    })
    this.props.form.setFieldsValue({
      poster: [{url: detailObj.coverUrl, uid: 'FirjdGoj0FyX6rVCgEPzouRC78dJ', name: detailObj.name}],
      replyObj: [{url: detailObj.replyImg, uid: 'FirjdGoj0FyX6rVCgEPzouRC78dJ', name: detailObj.name}]
    })
  }
  ClearKnow() {
    this.setState({courseName: ''},() => {
      this.InitClassHandle()
    })
  }
  getToken=() =>{
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					infourl: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
  changeCourse = (e) => {
    this.setState({courseName: e.target.value})
  }
  submitOk = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if(!err) {
        // console.log(values)
        // if(!values.poster[0].url){
        //   return message.error('请重新上传付费课封面')
        // }
        // if(!values.replyObj[0].url){
        //   return message.error('请重新上传客服话术图片')
        // }
        let {typeQ, infourl, detailObj } = this.state
        let params = {
          subjectId: this.state.subjectId,
          courseName: values.courseName,
          coverUrl: values.poster[0].url?values.poster[0].url:infourl + '/' + values.poster[0].response.key,
          price: values.price,
          reply: values.reply,
          replyImg: values.replyObj[0].url?values.replyObj[0].url : values.replyObj[0].response.data.url,
          payPeople: values.payPeople
        }
        if(typeQ === 'edit'){
          params.id = detailObj.id
        }else{
          delete params.id
        }
        // console.log(params)
        let url = typeQ === 'add'?'paycourse/save':'paycourse/update'
        axios.post(url, params).then(res => {
          if(res.data.code !== '200') return message.error(res.data.msg)
          message.success(`${typeQ === 'add'?'新增':'编辑'}成功`)
          this.setState({showKnowName: false, detailObj: {}, fileListurl: '', kefuListurl: ''})
          this.props.form.resetFields();
          this.InitClassHandle()
        })
      }
    })
  }
  cancelForm = () => {
    this.props.form.resetFields();
    this.setState({showKnowName: false, fileListurl: '', kefuListurl: '', detailObj: {}})
  }
  normFile = e => {
		if (e.fileList.length === 2) {
			e.fileList = e.fileList.slice(-1);
		  message.warning("一个版本只能上传一个文件")
		};
		if (Array.isArray(e)) {
			return e;
		}
		return e && e.fileList;
	};
  handleChangefile = ({file, fileList}, type) => {
    if (file.status === 'uploading') {
      this.setState({ [type+'loading']: true });
      return;
    }
    if (file.percent === 100) {
      if (file.status === 'done') {
        // console.log(fileList)
        let url = type === 'fileList' ? this.state.infourl + '/' + fileList[0].response.hash: fileList[0].response.data.url
        // console.log(url)
        let fileL = {
					uid: fileList[0].uid,
					name: fileList[0].name,
					status: fileList[0].status,
					url: url,
					type: fileList[0].type
				}
				this.setState({ [type]: fileL, [type+'url']: url, [type+'loading']: false })
        // console.log(this.state.fileList)
      }else if (file.status === 'removed') {
        this.setState({ [type]: [], [type+'url']: '', [type+'loading']: false });
      }
    }
  }
  pageChange= (current) => {
    this.setState({pageNum: current},() => {
      this.InitClassHandle()
    })
  }
  sizeChange = (current, size) => {
    this.setState({size: size},() => {
      this.InitClassHandle()
    })
  }
  render() {
    let {dataSource, columns, pageNum, typeQ, subName, showKnowName, detailObj, apiUrl, total} = this.state
    const { getFieldDecorator } = this.props.form;
    const courseButton = (
      <div>
        <Icon type={this.state.fileListloading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    )
    const kefuuploadButton = (
      <div>
        <Icon type={this.state.kefuListloading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    )
    return (
      <div className="pay-detail">
        <div className="header-between">
          <span className="header-name">{subName}付费课</span>
          <span className="my-button-txt" onClick={()=>{
              this.props.history.push('/Pay')
            }}>返回上一级</span>
          </div>
				<Divider />
          <div className="search-center">
            <Input placeholder="搜索付费课名称" onChange={this.changeCourse} />
            <Button className='my-button-primary' type='primary' onClick={() => {
                this.InitClassHandle()
            }}>搜索</Button>
            <Button className="zip-left" onClick={() => {this.ClearKnow()}}>重置</Button>
            <Button className='my-button-primary rig-btn' type='primary' onClick={() => {
                this.handleKnow('add',{})
            }}>新增付费课</Button>
          </div>
          <DndProvider backend={HTML5Backend}>
            <Table dataSource={dataSource} columns={columns} pagination={false} rowKey={record => record.id} components={component} 
            onRow={(record, index) => ({
                index,
                moveRow: this.moveRow,
              })} />
            <Pagination className="table-pagination" total={total} current={pageNum} showSizeChanger showQuickJumper pageSizeOptions={['10','20','50','100']} onChange={this.pageChange} onShowSizeChange={this.sizeChange} />
          </DndProvider>
          <Modal title={`${typeQ === 'add'?'新增':'编辑'}付费课`} width="60%" className="pay-modal" visible={showKnowName} onOk={this.submitOk} onCancel={this.cancelForm}>
          <Form labelCol={{ span: 4 }} wrapperCol={{ span: 18 }} onSubmit={this.submitOk}>
						<FormItem label="付费课名称" name="courseName">
              {getFieldDecorator('courseName', {
              rules: [
                {required: true,message: '请输入付费课名称'},
                {max: 20,message: '最多输入20个字!'}
              ],
              initialValue: typeQ === 'edit'?detailObj.courseName:''
            })(<Input />)}
						</FormItem>
            <FormItem label="付费课封面" name="poster">
              {getFieldDecorator('poster', {
              rules: [{required: true,message: '请选择付费课'}],
              valuePropName: 'fileList',
							getValueFromEvent: this.normFile
            })(
                <Upload                
                  accept=".jpg, .png, .jpeg"
                  listType='picture-card'
                  className="course-pic"
                  action={qiniuUpUrl}
                  showUploadList={false}
                  beforeUpload={(file, fileList) => {
                    const isLt10M = file.size / 1024 / 1024 <= 2;
                    if (!isLt10M) {
                      return	message.error("文件大小限制在2M以下！");
                    }
                  }}
                  onChange={(e) => {this.handleChangefile(e, 'fileList')}}
                  data={{ token: this.state.token }}
                  >
                  {/* {uploadButton} */}
                  {this.state.fileListurl ? <img src={this.state.fileListurl} alt="avatar" /> : courseButton}
                </Upload>
            )}
            <p style={{ fontSize: '12px', color: '#ccc', marginTop: '-25px' }}>仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：672*384px</p>
						</FormItem>
            <FormItem label="价格" name="price">
              {getFieldDecorator('price', {
              rules: [
                {required: true, message: '请输入价格'},
                { validator: this.powerValidateForm }
              ],
              initialValue: typeQ === 'edit'?detailObj.price:''
            })(<Input placeholder="请输入价格,大于0" />)}
						</FormItem>

            <FormItem label="客服话术文字" name="reply">
              {getFieldDecorator('reply', {
              rules: [
                {required: true, message: '请输入客服话术文字'},
                {max: 100,message: '最多输入100个字!'}
              ],
              initialValue: typeQ === 'edit'?detailObj.reply:''
            })(<Input placeholder="请输入此课程客服自动回复话术" />)}
						</FormItem>

            <FormItem label="客服话术图片" name="replyObj">
              {getFieldDecorator('replyObj', {
              rules: [{required: true,message: '请选择客服话术图片'}],
              valuePropName: 'fileList',
              getValueFromEvent: this.normFile
            })(
              <Upload                
                  accept=".jpg, .png, .jpeg"
                  listType='picture-card'
                  className="kefu-pic"
                  showUploadList={false}
                  action={apiUrl+'/paycourse/reply/upload'}
                  beforeUpload={(file, fileList) => {
                    const isLt10M = file.size / 1024 / 1024 <= 2;
                    if (!isLt10M) {
                      return	message.error("文件大小限制在2M以下！");
                    }
                  }}
                  onChange={(e) => {this.handleChangefile(e, 'kefuList')}}
                  headers={{ Authorization: localStorage.getItem('token') }}
                  >
                  {this.state.kefuListurl? <img src={this.state.kefuListurl} alt="avatar" /> : kefuuploadButton}
                </Upload>
            )}
            <p style={{ fontSize: '12px', color: '#ccc', marginTop: '-25px' }}>仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：200*200px</p>
						</FormItem>
            <FormItem label="预设购买人数" name="payPeople">
              {getFieldDecorator('payPeople', {
              rules: [
                { validator: this.presetValidateForm }
              ],
              initialValue: typeQ === 'edit'?detailObj.payPeople:''
            })(<Input disabled={typeQ === 'edit'&&detailObj.payPeople !==0?true: false} placeholder="请输入大于等于1的正整数" />)}
						</FormItem>
					</Form>
          </Modal>
      </div>
    )
  }
}
export default Form.create()(PayDetail)